export type MicPermissionResult =
  | { ok: true }
  | { ok: false; reason: 'denied' | 'not-found' | 'unknown'; message: string }

export async function probeMicPermission(): Promise<MicPermissionResult> {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    stream.getTracks().forEach((track) => track.stop())
    return { ok: true }
  } catch (err) {
    if (err instanceof Error) {
      const reason =
        err.name === 'NotAllowedError'
          ? 'denied'
          : err.name === 'NotFoundError'
            ? 'not-found'
            : 'unknown'
      return { ok: false, reason, message: err.message }
    }
    return { ok: false, reason: 'unknown', message: 'Unknown microphone error' }
  }
}
